/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Chip, LinearProgress, Stack, Typography, Divider } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import MainCard from 'ui-component/cards/MainCard';
import SkeletonTotalCard from 'ui-component/cards/Skeleton/TotalIncomeCard';

// Debe coincidir con STEPS del OnboardingWizard (índice = onboardingStep)
const STEP_LABELS = ['Bienvenida', 'Habitaciones', 'Estancias', 'Precios', 'Datos del hotel', 'Sego IA', 'Final'];

export default function OnboardingFunnel({ isLoading, metricsData }) {
  const theme = useTheme();
  const funnel = metricsData?.onboardingFunnel;

  if (isLoading) return <SkeletonTotalCard />;

  const total = funnel?.totalStarted || 0;
  const completed = funnel?.completed || 0;
  const pending = funnel?.pendingByStep || [];
  const completionRate = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <MainCard sx={{ borderRadius: '12px', height: '100%' }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <RocketLaunchIcon sx={{ color: theme.palette.primary.main }} />
          </Box>
          <Box>
            <Typography variant="h5">Embudo de Onboarding</Typography>
            <Typography variant="caption" color="text.secondary">
              Hoteles nuevos y en qué paso del wizard van
            </Typography>
          </Box>
        </Stack>

        {total === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            Aún no hay hoteles registrados con el wizard de onboarding.
          </Typography>
        ) : (
          <>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h3">{completionRate}%</Typography>
              <Typography variant="body2" color="text.secondary">
                completan la configuración ({completed} de {total})
              </Typography>
            </Stack>
            <LinearProgress
              variant="determinate"
              value={completionRate}
              color="success"
              sx={{ height: 8, borderRadius: 1 }}
            />

            {pending.length > 0 && (
              <>
                <Divider />
                <Typography variant="subtitle2" color="text.secondary">
                  Pendientes por paso (donde abandonan):
                </Typography>
                <Stack spacing={1}>
                  {pending.map((p) => (
                    <Stack key={p.step} direction="row" justifyContent="space-between" alignItems="center">
                      <Typography variant="body2">
                        Paso {p.step + 1}: {STEP_LABELS[p.step] || 'Desconocido'}
                      </Typography>
                      <Chip label={`${p.count} ${p.count === 1 ? 'hotel' : 'hoteles'}`} size="small" color="warning" variant="outlined" />
                    </Stack>
                  ))}
                </Stack>
              </>
            )}
          </>
        )}
      </Stack>
    </MainCard>
  );
}
